module.exports = {
  isDocx: function(maybeDocx) {
    return _.has(maybeDocx, 'appProperties');
  }
};
